// src/components/Dashboard/AlertPanel.jsx
import React from "react";
import "../../styles/AlertPanel.css"; // optional: style ringkas

const AlertPanel = ({ alerts = [] }) => (
    <div className="alert-panel">
        {alerts.length === 0 && <div>Tiada notifikasi terkini.</div>}
        {alerts.map((alert, i) => (
            <div key={i} className="alert">
                {alert}
            </div>
        ))}
    </div>
);

export default AlertPanel;
